﻿
$(".page-element.wishYouWereHere .image").hover(
    function () {
        $(this).find('.play-button').attr("src", "/Images/play-button-hover.png");
    }, function () {
        $(this).find('.play-button').attr("src", "/Images/play-button.png");
});

